import React from "react";
import Translate, { useTranslateText } from "../Multilanguage/Translate";
import { ReactComponent as CloseIcon } from "../../assets/Icons/close.svg";
import { setAgeConfirmedForSession } from "../../utils/ageConfirmation";

const AgeConfirmModal = ({ onConfirm, onCancel }) => {
  const translateText = useTranslateText();

  const confirmHandler = () => {
    setAgeConfirmedForSession();
    onConfirm?.();
  };

  const declineHandler = () => {
    onCancel?.();
  };

  const getTranslatedText = (key, fallback) => {
    try {
      const text = translateText(key);
      if (!text || text.includes(key) || text === "undefined") {
        return fallback;
      }
      return text;
    } catch (e) {
      return fallback;
    }
  };

  return (
    <div className="ageConfirmModal" role="dialog" aria-modal="true" aria-label="Age Confirmation">
      <div className="overlayModal" onClick={declineHandler}></div>
      <div className="contents">
        <div className="closeContainer" onClick={declineHandler}>
          <CloseIcon />
        </div>
        <h3>{getTranslatedText('age_confirmation_title', 'Age Confirmation')}</h3>
        <h1>{getTranslatedText('age_confirmation_message', 'This content is intended for viewers 18 years of age or older. Are you 18 or older?')}</h1>
        <div className="buttons">
          <div className="buttonContainer" onClick={declineHandler}>
            <div className="background"></div>
            <button type="button">{getTranslatedText('age_confirmation_no', 'No')}</button>
          </div>

          <div className="buttonContainer" onClick={confirmHandler}>
            <div className="background"></div>
            <button type="button">{getTranslatedText('age_confirmation_yes', 'Yes')}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgeConfirmModal;
